import { HttpErrorResponse } from "@angular/common/http";
import { environment } from "@environments/environment";
import { BrowserOptions, browserTracingIntegration, replayIntegration } from "@sentry/angular";

export const SentryConfig: BrowserOptions = {
  environment: environment.production ? 'production' : 'development',
  release: environment.version,
  dsn: environment.sentryDsn,
  ignoreErrors: ["gtag is not defined", "Can't find variable: gtag"],
  beforeSend(event, hint) {
    // status:0 never reaches the browser (client abort/offline/CORS); real faults are 4xx/5xx which we keep. Drop regardless of visibility.
    const original = hint?.originalException;
    const message = event.exception?.values?.[0]?.value ?? '';
    if (
      (original instanceof HttpErrorResponse && original.status === 0) ||
      /Http failure response for .+: 0 Unknown Error/.test(message)
    ) {
      return null;
    }
    return event;
  },
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    browserTracingIntegration(),
    // Registers the Replay integration,
    // which automatically captures Session Replays
    replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ['https://dashboard.calenso.com', 'https://my.calenso.com/api', 'https://auth.calenso.com/api'],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.8,
};

/**
 * Web Component variant — the widget runs on the INTEGRATOR's page there, so Sentry must never
 * capture the partner site's errors, instrument their routing/fetches, or record their DOM:
 * - allowUrls: only events whose stack frames come from OUR bundles (served from deployUrl)
 * - no tracing / no replay integrations, no trace headers into host-page requests
 */
export const SentryWebComponentConfig: BrowserOptions = {
  environment: SentryConfig.environment,
  release: SentryConfig.release,
  dsn: SentryConfig.dsn,
  ignoreErrors: SentryConfig.ignoreErrors,
  beforeSend: SentryConfig.beforeSend,
  allowUrls: [environment.deployUrl],
  integrations: [],
  tracesSampleRate: 0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
};
